export default __webpack_public_path__ + "352294a41ac90a449d9746215329f79a.png";